<template>
  <div class="om-container">
    <div class="om-login">
      <div class="om-center om-main-logo">
        <img src="/static/img/logo.png" :alt="$tr('OmniWay', 'Login')">
      </div>
      <transition name="fade">
        <form v-if="isFormReady" class="om-form--login" autocomplete="off" @submit.prevent="loginAction">
          <div class="om-center">
            <img v-if="settings && settings.logo_url" class="om-user-logo" :src="settings.logo_url" :alt="$tr('Logo', 'Login')" >
            <img v-else="" class="om-user-logo"  src="/static/temp/logo-patrizia-aryton.png" :alt="$tr('Logo', 'Login')" >
          </div>
          <h3 v-if="settings" class="om-form--login__heading">
            {{ tr('Zaloguj się do systemu', 'Login') }}
            {{ settings.name }}
          </h3>
          <h3 v-else="" class="om-form--login__heading">
            {{ tr('Zaloguj się do systemu Aryton Omniway', 'Login') }}
          </h3>
          <div class="om-form--login__group">
            <input
              v-validate="validateRules.username"
              class="om-form--login__input--login"
              id="username"
              :class="{'is-invalid': errors.has('username'), 'is-not-empty': username.length}"
              v-model="username"
              name="username">
            <label class="om-form--login__label" for="username">{{ $tr('Login', 'Login') }}</label>
            <img class="input-icon" src="/static/img/icon-person.png" alt="">
          </div>
          <div class="om-form--login__group">
            <input
              v-validate="validateRules.password"
              class="om-form--login__input--login"
              id="password"
              :class="{'is-invalid': errors.has('password'), 'is-not-empty': password.length}"
              name="password"
              type="password"
              v-model="password">
            <label class="om-form--login__label" for="password">{{ tr('Hasło', 'Login') }}</label>
            <img class="input-icon" src="/static/img/icon-lock.png" alt="">
          </div>
          <div v-if="visibleSubdomain" class="om-form--login__group">
            <input
              class="om-form--login__input--login"
              id="subdomain"
              :class="{'is-not-empty': subdomain.length}"
              v-model="subdomain"
              name="subdomain">
            <label class="om-form--login__label" for="subdomain">{{ $tr('Subdomena (tymczasowo)', 'Login') }}</label>
            <img class="input-icon" src="/static/img/icon-person.png" alt="">
          </div>
          <div class="om-form--login__group">
            <button type="submit" v-on:click.prevent="loginAction" class="om-form--login--login__submit">
              {{ tr('Zaloguj się', 'Login') }}
            </button>
          </div>
        </form>
      </transition>
    </div>

  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      dev: false,
      visibleSubdomain: false,
      isFormReady: false,
      subdomain: '',
      username: '',
      password: '',
      validateRules: {
        username: { rules: { required: true } },
        password: { rules: { required: true } }
      },
      settings: null
    }
  },
  watch: {
    // for later implementation
  },
  methods: {
    tr (arg, ns) {
//      console.log('translator implementation')
      return arg
    },
    loginAction () {
      if (this.errors.count()) {
        return false
      }
      this.$http.post(this.$router.options.getApiRoute('login'), {
        username: this.username,
        password: this.password,
        subdomain: this.subdomain
      })
        .then(
          (resp) => {
            console.log(resp)
            if (resp.ok && resp.status === 200) {
              this.successAction(resp.body)
              if (resp.body.role === 'shop') {
                this.$router.push('/admin/order-list')
              } else {
                this.$router.push('/admin/return-list')
              }
            } else {
              this.errorAction()
              this.$alertify.notify(this.$tr('Błędne dane', 'Order'), 'error', 3)
            }
          },
          (resp) => {
            this.errorAction()
            this.$alertify.notify(this.$tr('Błędne dane', 'Order'), 'error', 3)
            console.log('err:')
            console.log(resp)
          }
        )
    },
    successAction (resp) {
      this.$store.commit('LOGIN', resp)
      return true
    },
    errorAction () {
      this.$store.commit('LOGOUT')
      return false
    },
    inspectURL () {
      if (typeof window.location === 'undefined' || this.dev) {
        this.visibleSubdomain = true
        return
      }
      let location = window.location.hostname
      let parts = location.split('.')
      if (parts.length < 3) {
        this.visibleSubdomain = true
        return
      }
      this.subdomain = parts[0]
    }
  },
  mounted () {
    // inactive until logo adding functionality will not be implemented
//    this.$http.get(this.$router.options.getApiRoute('settings'))
//      .then((res) => {
//        this.settings = res.body
//        this.$store.commit('UPDATE_DISPATCH_SETTINGS', res.body)
//      })
    this.inspectURL()
    setTimeout(() => {
      this.isFormReady = true
    }, 150)
  },
  computed: {
    // later use
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../assets/scss/settings";
  @import "../assets/scss/utilities";

  $omni-login-text-color: #919395;

  .om-main-logo{
    margin: 110px 0 68px;
  }
  .om-login{
    .om-form--login{
      box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
      background: $omni-color-grey;
      width: 714px;
      max-width: 100%;
      margin: 0 auto;
      padding: 45px 0 80px;
    }
  }
  .om-user-logo{
    width: 148px;
    max-width: 100%;
  }
  .om-form--login{
    &__heading{
      color: $omni-color-black;
      font-family: "Josefin Sans";
      font-size: 18px;
      font-weight: 300;
      line-height: 20px;
      text-align: center;
      margin: 22px 0 56px;
    }
    &__group{
      width: 342px;
      max-width: 100%;
      margin: 0 auto 13px;
      position: relative;
    }
    &__label{
      position: absolute;
      z-index: 2;
      color: #919395;
      font-family: 'Lato';
      font-size: 18px;
      font-weight: 300;
      top: 10px;
      left: 34px;
      line-height: 20px;
      transition: $omni-transition-fast;
    }
    @at-root .is-not-empty + &__label{
      top: -13px;
      line-height: 13px;
      font-size: 11px;
    }
    &__input--login{
      border: none;
      width: 100%;
      padding: 0 34px;
      background-color: $omni-color-white;
      height: 41px;
      line-height: 41px;
      color: $omni-login-text-color;
      font-family: 'Lato';
      font-size: 18px;
      font-weight: 300;
      position: relative;
      z-index: 1;
      @include w-placeholder{
        opacity: 1;
        color: $omni-login-text-color;
      }
    }
    &--login__submit{
      width: 342px;
      border: none;
      max-width: 100%;
      height: 40px;
      text-align: center;
      font-family: 'Lato';
      line-height: 40px;
      border-radius: 2px;
      background-color: $omni-color-black;
      color: $omni-color-white;
      font-size: 15px;
      font-weight: 400;
      text-transform: uppercase;
      cursor: pointer;
      margin: 17px 0 0;
    }
    .input-icon{
      position: absolute;
      display: block;
      right: 29px;
      top: 12px;
      z-index: 2;
    }
  }
</style>



// WEBPACK FOOTER //
// Login.vue?3f1ad921